import React from 'react'
import queryString from 'query-string'
import header_logo from './img/header_logo.png'
import hero_banner from './img/chanel_rsvp_banner_mobile.jpg'
import hero_banner_2x from './img/chanel_rsvp_banner_mobile@2x.jpg'
import hero_banner_md from './img/chanel_rsvp_banner_desktop.jpg'
import hero_banner_md_2x from './img/chanel_rsvp_banner_desktop@2x.jpg'
import {
  Container,
  CenteredContent,
  Link,
  Header,
  HeaderLogo,
  Dropdown,
  HeroBanner,
  Event,
  EventTitle,
  EventDescription,
  EventDetails,
  EventData,
  RsvpWrapper } from './styles'

import './css/page.css'

const params = queryString.parse(window.location.search);

export default class App extends React.Component {
  goToFooterPage = (url) => {
    const mapper = {
      en: 'en_HK',
      'zh-HK': 'zh_HK',
      'zh-CN': 'zh_CN',
    };
    window.open(url.replace(':locale', mapper[document.documentElement.lang]));
  }

  render() {
    return <div>
      { !params.webview &&
        <Header>
          <HeaderLogo>
            <img className="img-responsive" src={header_logo} alt="header logo" />
          </HeaderLogo>
          <div className="header__locale-menu">
            <Dropdown>
              <Link className="dropdown__label" onClick={this.props.openLanguageSwitcher}>
                <span lang="en">en</span>
                <span lang="zh-HK">繁</span>
                <span lang="zh-CN">简</span>
              </Link>
            </Dropdown>
          </div>
        </Header>
      }

      <HeroBanner src={hero_banner} src2x={hero_banner_2x} srcMd={hero_banner_md} srcMd2x={hero_banner_md_2x} />

      <Event>
        <EventTitle></EventTitle>
        <CenteredContent maxWidth="284px">
          <Container center>
            <div className="carousel-inner" role="listbox">
              <div className="item active text">
                <CenteredContent maxWidth="600px">
                  <EventDescription block lang="en">
                    Your invitation to discover LES EAUX DE CHANEL<br />
                    Three Fragrance inspired by destinations dear to Gabrielle Chanel.<br />
                    <br />
                    A New chapter in the history of CHANEL fragrances. A sensation of freshness. A journey in every spray.<br />
                    <br />
                    Discover LES EAUX DE CHANEL at a unique event experience from 26-Jul to 27-Jul and 2-Aug to 3-Aug at ifc Boutique.
                  </EventDescription>

                  <EventDescription block lang="zh-HK">
                    CHANEL誠邀您體驗全新LES EAUX DE CHANEL香水系列<br />
                    LES EAUX DE CHANEL的靈感源自Chanel女士鍾情的三個地方。<br />
                    <br />
                    為CHANEL香水歷史譜寫全新篇章，煥發清新寫意的享受。一款香水，盛載一趟旅程。<br />
                    <br />
                    由7月26日至7月27日及8月2日至8月3日，親臨Chanel Beaute ifc踏上LES EAUX DE CHANEL香氛旅程。
                  </EventDescription>

                  <EventDescription block lang="zh-CN">
                    CHANEL诚邀您体验全新LES EAUX DE CHANEL香水系列<br />
                    LES EAUX DE CHANEL的灵感源自Chanel女士钟情的三个地方。<br />
                    <br />
                    为CHANEL香水历史谱写全新篇章，焕发清新写意的享受。一款香水，盛载一趟旅程。<br />
                    <br />
                    由7月26日至7月27日及8月2日至8月3日，亲临Chanel Beaute ifc踏上LES EAUX DE CHANEL香氛旅程。
                  </EventDescription>                  

                  <EventDetails>
                    <EventData lang="en">
                      Shop 1060,<br />PODIUM LEVEL ONE,<br />IFC MALL
                    </EventData>
                    <EventData lang="zh-HK">
                      國際金融中心商場<br />第1層1060舖
                    </EventData>
                    <EventData lang="zh-CN">
                      国际金融中心商场<br />第1层1060铺
                    </EventData>
                    <EventData lang="en">
                      26–27 July 2018<br />
                      &amp;<br />
                      2–3 August 2018
                    </EventData>
                    <EventData lang="zh-HK">
                      2018年7月26–27日<br />
                      2018年8月2-3日
                    </EventData>
                    <EventData lang="zh-CN">
                      2018年7月26-27日<br />
                      2018年8月2-3日
                    </EventData>
                  </EventDetails>
                </CenteredContent>
              </div>
            </div>
          </Container>
        </CenteredContent>
      </Event>

      <RsvpWrapper>
        {this.props.children}
      </RsvpWrapper>

      { !params.webview &&
        <div className="footer">
          <div className="footer_wrapper">
            <a onClick={() => this.goToFooterPage('https://www.chanel.com/:locale/#contact', 'Contact Us')} className="element" target="_blank" rel="noopener noreferrer">
              <span lang="en">Contact Us</span>
              <span lang="zh-HK">聯絡我們</span>
              <span lang="zh-CN">联络我们</span>
            </a>
            <a onClick={() => this.goToFooterPage('https://www.chanel.com/:locale/#legal', 'Legal Statement')} className="element" target="_blank" rel="noopener noreferrer">
              <span lang="en">Legal Statement</span>
              <span lang="zh-HK">法律聲明</span>
              <span lang="zh-CN">法律声明</span>
            </a>
            <a onClick={() => this.goToFooterPage('https://www.chanel.com/:locale/#privacy', 'Privacy Policy')} className="element" target="_blank" rel="noopener noreferrer">
              <span lang="en">Privacy Policy</span>
              <span lang="zh-HK">私隱政策</span>
              <span lang="zh-CN">私隐政策</span>
            </a>
          </div>
        </div>
      }
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/Page.js